<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height overflow-y-hidden">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle">
          <template v-slot:body>
            <v-row no-gutters>
              <v-col cols="12" class="pa-0">
                <v-row no-gutters>
                  <v-col class="pb-1">
                    <i-card-top
                      class="d-md-flex"
                      outlined
                      :useBtnList="useBtnList"
                      :customBtnList="customBtnList"
                      :class="[setBtnColor]"
                      @btnSave="btnSave()" @btnPrint="btnPrint()" @btnDelete="btnDelete()"
                      @btnSaveAsExcel="btnSaveAsExcel()"
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <i-label :label="'Confirm Div :'" />
                          <v-col cols="1">
                            <v-select
                              v-model="whDiv"
                              :items="whDivList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="getBlock()"
                            />
                          </v-col>
                          <i-label :label="'Ship No :'" class="pl-2"/>
                          <v-col cols="1">
                            <v-select
                              v-model="shipNo"
                              :items="shipNoList"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="getBlock()"
                            />
                          </v-col>
                          <i-label :label="'Block :'" class="pl-2"/>
                          <v-col cols="1">
                            <v-select
                              v-model="block"
                              :items="blockList"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="getRes()"
                            />
                          </v-col>
                          <i-label :label="'Res List :'" class="pl-2"/>
                          <v-col cols="2">
                            <v-select
                              v-model="dlyNo"
                              :items="dlyNoList"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="getMain()"
                            />
                          </v-col>
                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>


                <v-row no-gutters>
                  <v-col cols="12" class="pt-1">
                    <!-- class="doubleListBox01" -->
                    <DxDataGrid
                      height="310"
                      id="gridMain"
                      :ref="gridMainRef"
                      :data-source="gridMainList" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="false"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                    >
                      <DxPaging :enabled="false" />
                      <DxPager :visible="false" />

                      <DxColumn data-field="dlySeq" caption="Seq." width="3%" data-type="number" format="#,###" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="shipNo" caption="Ship No" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="block" caption="Block" width="5%" alignment="center" :allow-editing="false" />

                      <DxColumn data-field="cutGrp" width="5%" alignment="center" :allow-editing="false" header-cell-template="Cutting" />
                      <template #Cutting>
                        <div>Cutting<br>Group</div>
                      </template>
                      <DxColumn data-field="keySer" width="5%" alignment="center" :allow-editing="false" header-cell-template="Ser" />
                      <template #Ser>
                        <div>Ser<br>No</div>
                      </template>
                      <DxColumn data-field="newLotGbn" width="5%" alignment="center" :allow-editing="false" header-cell-template="Assy" />
                      <template #Assy>
                        <div>Assy<br>Lot</div>
                      </template>
                      <DxColumn data-field="stlLot" width="5%" alignment="center" :allow-editing="false" header-cell-template="Steel" />
                      <template #Steel>
                        <div>Steel<br>Lot</div>
                      </template>
                      <DxColumn data-field="dwgNo" width="5%" alignment="center" :allow-editing="false" header-cell-template="Drawing" />
                      <template #Drawing>
                        <div>Drawing<br>Page</div>
                      </template>
                      <DxColumn data-field="nextAssy" caption="Next Assy" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="assyNo" caption="Assy" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="pcsNo" caption="PCS" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="pcsType" caption="Specification" width="20%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="assyStg" width="5%" alignment="center" :allow-editing="false" header-cell-template="AssyStage" />
                      <template #AssyStage>
                        <div>Assy<br>Stage</div>
                      </template>
                      <DxColumn data-field="pcsQty" width="5%" alignment="center" :allow-editing="false" header-cell-template="Req" />
                      <template #Req>
                        <div>Req.<br>Qty</div>
                      </template>
                      <DxColumn data-field="pcsWeight" width="5%" alignment="center" :allow-editing="false" header-cell-template="PCS" />
                      <template #PCS>
                        <div>PCS<br>Weight</div>
                      </template>
                      <DxColumn data-field="pcsArea" caption="Area" width="5%" alignment="center" :allow-editing="false" />

                      <DxSummary>
                          <DxTotalItem column="shipNo" summary-type="count" display-format="SUM" />
                          <DxTotalItem column="pcsQty" summary-type="sum" :customize-text="totalFormat" />
                          <DxTotalItem column="pcsWeight" summary-type="sum" :customize-text="totalFormat" />
                      </DxSummary>

                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" class="pt-2">
                <v-row no-gutters>
                  <v-col class="">
                    <i-card-top
                      class="d-md-flex"
                      outlined
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2">
                          <i-label :label="'Ship No :'"/>
                          <v-col cols="1">
                            <v-select
                              v-model="shipNo2"
                              :items="shipNoList2"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="getBlock2()"
                            />
                          </v-col>
                          <i-label :label="'Block :'" class="pl-2"/>
                          <v-col cols="1">
                            <v-select
                              v-model="block2"
                              :items="blockList2"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="getMain2()"
                            />
                          </v-col>

                          <v-checkbox v-model="isAppend" label="Append Delivery Note" class="pl-2" :disabled="delyNo === 'New' || whYn === 'Y'"
                                              true-value="Y" false-value="N" />

                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="12" class="pt-1">
                    <DxDataGrid
                      class="doubleListBox07"
                      id="gridMain2"
                      :ref="gridMain2Ref"
                      :data-source="gridMainList2" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="false"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                      :selection="{ mode: 'none' }"
                      @cellPrepared="cellPrepared"
                    >
                      <DxPaging :enabled="false"/>
                      <DxPager :visible="false" />
                      <DxEditing :use-icons="true" mode="cell" />
                      
                      <DxColumn data-field="selChek" width="3%" alignment="center" :allow-editing="false" header-cell-template="selHeader" cell-template="selChkRow" />
                      <template #selHeader ="{ data: cellInfo }">
                        <DxCheckBox :value="false" :onValueChanged="value => onValueChanged(value, cellInfo)"  />
                      </template>
                      <template #selChkRow ="{ data: cellInfo }">
                        <DxCheckBox :value="cellInfo.value" :disabled="cellInfo.data.chk === 'N' ? true : false" 
											    :onValueChanged="value => onValueChanged(value, cellInfo)"  />
                      </template>


                      <DxColumn data-field="cutGrp" width="5%" alignment="center" :allow-editing="false" header-cell-template="Cutting" />
                      <template #Cutting>
                        <div>Cutting<br>Group</div>
                      </template>
                      <DxColumn data-field="keySer" width="5%" alignment="center" :allow-editing="false" header-cell-template="Ser" />
                      <template #Ser>
                        <div>Ser<br>No</div>
                      </template>
                      <DxColumn data-field="newLotGbn" width="5%" alignment="center" :allow-editing="false" header-cell-template="AssyLot" />
                      <template #AssyLot>
                        <div>Assy<br>Lot</div>
                      </template>
                      <DxColumn data-field="stlLot" width="5%" alignment="center" :allow-editing="false" header-cell-template="Steel" />
                      <template #Steel>
                        <div>Steel<br>Lot</div>
                      </template>
                      <DxColumn data-field="dwgNo" width="5%" alignment="center" :allow-editing="false" header-cell-template="Drawing" />
                      <template #Drawing>
                        <div>Drawing<br>Page</div>
                      </template>
                      <DxColumn data-field="nextAssy" caption="Next Assy" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="assyNo" caption="Assy" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="pcsNo" caption="PCS" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="pcsType" caption="Specification" width="20%" alignment="left" :allow-editing="false" />
                      <DxColumn data-field="asyStg" width="5%" alignment="center" :allow-editing="false" header-cell-template="AssyStage" />
                      <template #AssyStage>
                        <div>Assy<br>Stage</div>
                      </template>
                      <DxColumn data-field="pcsQty" width="5%" alignment="right" :allow-editing="false" header-cell-template="PCS" />
                      <template #PCS>
                        <div>PCS<br>Qty</div>
                      </template>
                      <DxColumn data-field="pcsWeight" width="5%" alignment="right" :allow-editing="false" header-cell-template="PCSWeight" />
                      <template #PCSWeight>
                        <div>PCS<br>Weight</div>
                      </template>
                      <DxColumn data-field="pcsArea" caption="Area" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="dlyNo" caption="Dely No" width="5%" alignment="right" :allow-editing="false"/>

                      <DxSummary>
                          <DxTotalItem column="cutGrp" summary-type="count" display-format="SUM" />
                          <DxTotalItem column="pcsQty" summary-type="sum" :customize-text="totalFormat" />
                          <DxTotalItem column="pcsWeight" summary-type="sum" :customize-text="totalFormat" />
                      </DxSummary>

                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { getShipNoList,getBlockList,getDlyNoList, epmsa010DelyNo, epmsa012detailKl,epmsa013Kl,epmsa010saveKl,
    epmsa010deleteKl , epmsa012klxls } from '@/api/view/hip/A/epmsa010_kl'
import { reportView } from '@/api/view/hip/common/common'
import notify from 'devextreme/ui/notify'
import dayjs from 'dayjs';
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getNumComma, toNum } from '@/utils/common.js'

export default {
  name: 'epmsa010_kl',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox,
  },
  data() {
    return {
      makerCd: this.$store.state.user.makerCd,
      userId: this.$store.state.user.userId,
      menuTitle: this.$route.meta.title,
      gridMainRef: 'gridMainRef',
      gridMain2Ref: 'gridMain2Ref',

      useBtnList: ['btnSave','btnPrint', 'btnSaveAsExcel','btnDelete'],
      customBtnList: [
        { id: 'btnSaveAsExcel', text: 'Save as Excel', icon: 'excel' }
      ],
      setBtnColor: 'setBtnColor',

      gridMainList: [],
      gridMainList2: [],

      whDiv: '',
      whDivList: [],

      shipNo: '',
      shipNoList: [],
      block: '',
      blockList: [],
      shipNo2: '',
      shipNoList2: [],
      block2: '',
      blockList2: [],
      dlyNo: '',
      dlyNoList: [],
      delyNo: '',
      isAppend: 'N'

    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.gridMainRef)
    },
    gridInstance2() {
      return this.GetDataGrid(this.gridMain2Ref)
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    totalFormat(e) {
            const result = getNumComma(Number(e.value.toFixed(2)), 2)
            return result
    },
    async init() {
      this.gridInstance.option('defaultPaging', false)
      this.gridInstance2.option('defaultPaging', false)
      this.getList()
      this.getShipNoList()
    },
    async getList(){
      try {
        this.openLoading('searching')
        let params = {
          code: '',
          codegr: '',
          prtCode: 'WH_DIV_A',
          userFlag: 'Y'
        }
        await getCmChildCode(params).then(res => {
          this.whDivList = res.list
          this.whDiv = res.list[0]
        })
      } finally {
        this.endLoading()
      }
    },
    async getShipNoList(){
      let params = {

      }
      await getShipNoList(params).then(res => {
        this.shipNoList.push('Select')
        this.shipNoList2.push('Select')
        res.list.forEach(e => {
          this.shipNoList.push(e.shipNo)
          this.shipNoList2.push(e.shipNo)
        });
        this.shipNo = this.shipNoList[0]
        this.shipNo2 = this.shipNoList2[0]
      })
      this.getRes()
    },
    async getBlock(){
      let param = {
        shipNo: this.shipNo
      }
      this.openLoading('searching')
      await getBlockList(param).then(res => {
        this.blockList = []
        this.blockList.push('')
        res.list.forEach(e => {
          this.blockList.push(e.block)
        });
        this.block = this.blockList[0]
      }).finally(() => {
        this.endLoading()
        this.getRes()
      })
    },
    async getBlock2(){
      let param = {
        shipNo: this.shipNo2
      }
      this.openLoading('searching')
      await getBlockList(param).then(res => {
        this.blockList2 = []
        this.blockList2.push('')
        res.list.forEach(e => {
          this.blockList2.push(e.block)
        });
        this.block2 = this.blockList2[0]
      }).finally(() => {
        this.endLoading()
        this.getMain2()
      })
    },
    async getRes(){
      let param = {
        whDiv: this.whDiv.code,
        shipNo: this.shipNo === 'Select' ? '' : this.shipNo,
        block: !this.block ? '%' : this.block 
      }
      this.openLoading('searching')
      await getDlyNoList(param).then(res => {
        this.dlyNoList = []
        this.dlyNoList.push('New')
        res.list.forEach(e => {
          this.dlyNoList.push(e.dlyNo)
        });
        this.dlyNo= this.dlyNoList[0]
      }).finally(() => {
        this.endLoading()
      })
    },
    async getMain(){
      try {
        this.gridMainList = []
        this.isAppend = 'N'
        this.openLoading('searching')
        let param = {
          dlyNo: this.dlyNo,
          shipNo: this.shipNo == 'Select' ? '%' : this.shipNo,
          block: !this.block ? '%' : this.block 
        }
        await epmsa012detailKl(param).then(res => {
          let cnt = 0
          res.list.forEach(e => {
            e.id = cnt++
          });
          this.gridMainList = res.list
        })
      } finally {
        this.endLoading()
      }
    },
    async getMain2(){
      try {
        this.openLoading('searching')
        this.gridMainList2 = []
        let param = {
          shipNo: this.shipNo2 === 'Select' ? '' : this.shipNo2,
          block: this.block2
        }
        await epmsa013Kl(param).then(res => {
          if(res.list.length > 0){
            let cnt = 0
            res.list.forEach(e => {
              e.id = cnt++
              e.selChek = false
            })
            this.gridMainList2 = res.list
          }
        })
      } finally {
        this.endLoading()
      }
    },
    async btnSave(){
      var selectedMainRows = await this.gridMainList2
      let param = []
      
      //console.log("before: " + this.dlyNo)
      //console.log("whDiv: " + this.whDiv.code)

      if(this.dlyNo == '' || this.dlyNo == null || this.dlyNo == 'New' || this.isAppend ==='N' ) {
          await epmsa010DelyNo().then(res => {
            this.delyNo =  res.list[0].dlyNo
          })
      }else {
        this.delyNo = this.dlyNo
      }
      // if((!this.dlyNo == '' || !this.dlyNo == null  || !this.dlyNo == null ) && this.isAppend ==='Y') {
      //   this.delyNo = this.dlyNo
      // } else {
      //   await epmsa010DelyNo().then(res => {
      //     this.delyNo =  res.list[0].dlyNo
      //   })
      // }

      //console.log("after: " + this.delyNo)

      // await epmsa010DelyNo().then(res => {
      //   this.delyNo =  res.list[0].dlyNo
      // })
      
      if(this.gridMainList2.length > 0){
        for(var row of selectedMainRows){
          if(row.selChek === true){
            row.dlyNo = this.delyNo
            row.userId = this.userId
            row.ls = !row.dlyNo ? '2' : '1'
            param.push(row)
          }
        }
      }
      
      this.openLoading('searching')
      try {
        this.vToastifyPrompt(
          this.$t('Do you want to save the data?'),
          'info',
            current => {
              console.log(param)
              epmsa010saveKl(param) .then(res => {
                  if(res.body === 'Y'){
                    notify(this.$t('Saving is completed.'), 'success', 3000)
                    this.shipNo = this.shipNo2
                    this.gridMainList = []
                    this.getBlock()
                    this.getMain2()
                    this.endLoading()
                  } else {
                    this.vToastify(this.$t(res.body), 'warn')
                  }
                })
                .finally( () => {
                  this.endLoading()
                })
                
                

            },
          null,
          true
        )
      } finally {
        this.endLoading()
      }
    },
    btnPrint(){
      if(!this.dlyNo){
        this.vToastify(this.$t("Select Delivery No."), 'warn')
        return
      }
      const param = {
        fileName: 'epmsa012.jrxml',
        as_dly_no: this.dlyNo,
        as_ship_no: this.shipNo == 'Select' ? '%' : this.shipNo,
        as_blk: !this.block ? '%' : this.block 
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    async btnDelete(){
      await this.gridInstance.saveEditData()
      var selectedMainRows = await this.gridInstance.getSelectedRowsData()

      if(!selectedMainRows.length){
        this.vToastify(this.$t("Data is not selected for delete."), 'warn')
        return
      }

      try{
        this.openLoading('searching')
        this.vToastifyPrompt(
          this.$t('Do you want to delete?'),
          'info',
            current => {
              epmsa010deleteKl(selectedMainRows)
                .then(res => {
                  const result = res.body
                  if(result == 'Y'){
                    notify(this.$t('Delete is complete.'), 'success', 3000)
                  } else {
                    this.vToastify(this.$t(result), 'warn')
                  }
                })
                .catch(error => {
                  this.vToastify(error, 'warn')
                  this.endLoading()
                })
                .finally(() => {
                  this.gridInstance.clearSelection()
                  this.getBlock()
                  this.getMain()
                })
            },
          null,
          true
        )
      } finally {
        this.endLoading()
      }
    },
    btnSaveAsExcel(){
      if(!this.dlyNo){
        this.vToastify(this.$t("Select Delivery No."), 'warn')
        return
      }
      const param = {
        dlyNo: this.dlyNo,
        shipNo: this.shipNo == 'Select' ? '' : this.shipNo,
        block: this.block,
      }
      epmsa012klxls(param)
    },
    async onValueChanged(value, cellInfo){
      if(cellInfo.rowType === 'header') {
        for(let i = 0; i < this.gridMainList2.length; i++) {
          let chk = await this.gridInstance2.byKey(i)
          //console.log(chk)

          if(chk.chk == 'Y'){
            this.gridMainList2[i].selChek = value.value
            if(value.value) {
              this.gridInstance2.selectRows(i , true)
            } else {
              this.gridInstance2.deselectAll()
            }
          }
        }
      } else {
        this.gridMainList2[cellInfo.rowIndex].selChek = value.value
        if(value.value) {
          this.gridInstance2.selectRows([cellInfo.rowIndex], true)
        } else {
          this.gridInstance2.deselectRows([cellInfo.rowIndex])
        }
      }

    },
    async cellPrepared(e){
      if(e.rowType === 'header'){

      } else {
        if(e.data.chk === 'N'){
          e.cellElement.style.backgroundColor = '#CCFFCC'
          e.cellElement.style.backgroundColor = '#CCFFCC'
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$redBtn: #FF0000;
.setBtnColor::v-deep {
  [role=btnDelete]{
    .v-btn__content {
      div {
        color: #{$redBtn} !important;
      }

      i {
        color: #{$redBtn} !important;
      }
    }
  }
}
</style>
